import React, { useState } from 'react';
import { Colors } from 'library';
import { Link, Modal, Stack, Text } from 'library/ui';
import ErrorIcon from '@mui/icons-material/Error';

export default function ActionRequired() {
    const [open, setOpen] = useState(false);
    return (
        <div style={{ paddingTop: 12, paddingBottom: 6 }}>
            <Link
                onClick={() => setOpen(true)}
                color={Colors.error}
                icon={<ErrorIcon style={{ color: Colors.error, height: 18, width: 18 }} />}
            >
                Action Required
            </Link>
            {open && (
                <Modal onClose={() => setOpen(false)}>
                    <Stack gap="md">
                        <Text weight="bold" size="lg">
                            In order to confirm the workers compliance before they work, please ensure that you have
                            completed the following steps:
                        </Text>
                        <Stack gap="none">
                            <Text>1. Log into Clearinghouse</Text>
                            <Text>2. Click on the &apos;Background Screening&apos; tab</Text>
                            <Text>3. Click &apos;Search&apos;</Text>
                            <Text>
                                4. Type in the workers social security number (click the three dots next to their name
                                on Tandem)
                            </Text>
                            <Text>5. Add the worker to your roster</Text>
                        </Stack>
                        <Text weight="bold" size="sm">
                            Please note: If the worker has &apos;90 Day Lapse in Employment&apos; listed, please click
                            &apos;Initiate Resubmission&apos;. Then, you can add them to your roster.
                        </Text>
                        <Text size="sm" italic tone="secondary">
                            If you have any questions or trouble adding the worker to your roster, please email
                            support@join-tandem.com.
                        </Text>
                    </Stack>
                </Modal>
            )}
        </div>
    );
}
